// Plataforma nueva (app-data.data-bunker.ai): la misma funcionalidad de la plataforma de siempre, toda en
// Glass & Depth. Se compila sólo con REACT_APP_UI=nueva (ver src/index.js) y no carga nada del CSS ni de los
// componentes de la de siempre: los módulos viven en src/nueva/modulos y reutilizan src/services y src/utils.
// Contratos y reglas para migrar un módulo: docs/plataforma-nueva/README.md.
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from '../i18n';
import { OrganizationProvider } from '../contexts/OrganizationContext';
import { ConfigUsuarioProvider } from './app/ConfigUsuario';
import { TemaGlobal } from './app/tema';
import Rutas from './app/Rutas';
import Acceso from './shell/Acceso';

// El tema vive en <TemaGlobal> (app/tema.js) y no aquí: así cambiarlo no vuelve a pintar toda la plataforma.
export default function AppNueva() {
  return (
    <TemaGlobal>
      <LanguageProvider>
        <Acceso>
          {({ user, signOut }) => (
            <OrganizationProvider>
              <BrowserRouter>
                <ConfigUsuarioProvider user={user} signOut={signOut}>
                  <Rutas />
                </ConfigUsuarioProvider>
              </BrowserRouter>
            </OrganizationProvider>
          )}
        </Acceso>
      </LanguageProvider>
    </TemaGlobal>
  );
}
